import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationDE from './locales/de/translation.json'
import translationEN from './locales/en/translation.json'
import translationRU from './locales/ru/translation.json'

import { lang } from './config'

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  ru: {
    translation: translationRU,
  },
}

i18n
  .use(initReactI18next)

  .init({
    lng: lang,

    resources,

    fallbackLng: 'en',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    react: {
      wait: true,
    },

    returnEmptyString: false,
  })

export default i18n
